import { useIntl } from "react-intl";
import ControlledInput from "../../../../components/ControlledInputs/input";
import {
  FlowNameContainer,
  CountryFlagIcon,
  RemoveTranslationButton,
} from "../styles";
import brazilFlag from "../../../../assets/images/brazil-flag.png";
import ukFlag from "../../../../assets/images/uk-flag.png";

/**
 * Componente reutilizável para campos de tradução
 * Mantém a mesma funcionalidade do código original
 */
const TranslationField = ({
  name,
  control,
  formState,
  translationKey,
  onRemove,
  required = true,
  placeholder,
  max = 100,
  inactivate,
  "data-test": dataTest,
}) => {
  const intl = useIntl();

  const getCountryFlag = () => {
    const currentLocale = intl.locale;

    if (currentLocale === "en" || currentLocale === "en-US") return brazilFlag;
    else return ukFlag;
  };

  // Função para buscar o erro no formState aninhado
  const getNestedError = (errors, path) => {
    const keys = path.split(".");
    let current = errors;
    for (const key of keys) {
      if (current && current[key]) {
        current = current[key];
      } else {
        return null;
      }
    }
    return current?.message || null;
  };

  // Busca o erro correto para o campo
  const errorMessage = getNestedError(formState?.errors, name);

  return (
    <FlowNameContainer>
      <CountryFlagIcon
        src={getCountryFlag(translationKey)}
        alt="country icon"
        hasLabel={false}
      />
      <div style={{ display: "flex", alignItems: "flex-start", width: "100%" }}>
        <ControlledInput
          data-test={dataTest ? `${dataTest}-input` : undefined}
          disabled={inactivate}
          name={name}
          control={control}
          formState={{
            ...formState,
            errors: {
              [name]: { message: errorMessage },
            },
          }}
          placeholder={
            placeholder || intl.formatMessage({ id: "PLACEHOLDER_FLOW_NAME" })
          }
          required={required}
          max={max}
          width="100%"
        />

        {onRemove && (
          <RemoveTranslationButton
            data-test={dataTest ? `remove-${dataTest}` : undefined}
            disabled={inactivate}
            type="button"
            onClick={() => onRemove(translationKey)}
          >
            {intl.formatMessage({ id: "remove" })}
          </RemoveTranslationButton>
        )}
      </div>
    </FlowNameContainer>
  );
};

export default TranslationField;
